import { Component, Input, OnInit } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'

export function createAddressForm(addr?: any, isRequired = true): FormGroup {
  return new FormGroup({
    address: new FormControl(addr?.address, isRequired ? [Validators.required] : []),
    city: new FormControl(addr?.city, isRequired ? [Validators.required] : []),
    country: new FormControl(addr?.country, isRequired ? [Validators.required] : []),
    country_code: new FormControl(addr?.countryCode || addr?.country_code, isRequired ? [Validators.required] : []),
    postal_code: new FormControl(addr?.postalCode || addr?.postal_code, isRequired ? [Validators.required] : []),
    state: new FormControl(addr?.state, isRequired ? [Validators.required] : []),
  })
}

@Component({
  selector: 'app-address-form',
  templateUrl: './AddressForm.component.html',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
})
export class AddressFormComponent implements OnInit {
  @Input() form: FormGroup

  ngOnInit() {}
}
